import { gql } from '@apollo/client';

export const UNLINK_STAFF_FROM_PATIENT = gql`
  mutation unlinkUserFromPatient($data: PatientUserIdsInput!) {
    unlinkUserFromPatient(data: $data)
  }
`;
